export default __webpack_public_path__ + "static/media/arrow-down-b.498b0b56.svg";